import { type EditorPlugin } from '../../types/aha-editor';

const EmbedSchemaPlugin: EditorPlugin = {
  id: 'embedSchema',
  name: 'Embed Schema plugin',
  schema: {
    embed: {
      isInline: true,
      isVoid: true,
    },
  },
};

export default EmbedSchemaPlugin;
